export default __webpack_public_path__ + "static/media/7SA510.1475ee3b.jpg";